import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./Pages/ScrollToTop";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Services from "./components/Services/Services";
import TrustedBy from "./components/TrustedBy/TrustedBy";
import Ourteam from "./components/Ourteam/Ourteam";
import Blog from "./components/Blog/Blog";
import Footer from "./components/Footer/Footer";
import SoilInvestigation from "./Pages/SoilInvestigation";
import RechargeWell from "./Pages/RechargeWell";
import PumpingTest from "./Pages/PumpingTest";
import TamGrouting from "./Pages/TamGrouting";
import FissureGrouting from "./Pages/FissureGrouting";
import JetGrouting from "./Pages/JetGrouting";
import InstrumentationMonitoring from "./Pages/InstrumentationMonitoring";
import ShaftManholePipeJacking from "./Pages/ShaftManholePipeJacking";
import Projects from "./Pages/Projects";
import AboutUs from "./Pages/AboutUs";
import ContactUs from "./Pages/ContactUs";
import WhatsAppButton from "./components/WhatsAppButton";
import Certifications from "./components/Certifications/Certifications";

// Home Page — all sections together
// NOTE: <Header/> removed from here — it's already rendered once,
// globally, inside <Router> below. Having it in both places was
// causing the header to render twice on the home page.
function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <TrustedBy />
      <Ourteam />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services/soil-investigation" element={<SoilInvestigation />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/services/recharge-well" element={<RechargeWell />} />
        <Route path="/services/pumping-test" element={<PumpingTest />} />
        <Route path="/services/tam-grouting" element={<TamGrouting />} />
        <Route path="/services/fissure-grouting" element={<FissureGrouting />} />
        <Route path="/services/jet-grouting" element={<JetGrouting />} />
        <Route path="/services/instrumentation" element={<InstrumentationMonitoring />} />
        <Route path="/services/shaft-pipe" element={<ShaftManholePipeJacking />} />
        <Route path="/projects" element={<Projects />} />
        {/* Add more service routes here later:
        <Route path="/services/pumping-test" element={<PumpingTest />} />
        <Route path="/services/tam-grouting" element={<TamGrouting />} />
        */}
      </Routes>
      <WhatsAppButton />  {/* ✅ Outside Routes — shows on every page */}
      <Footer />
    </Router>
  );
}